import { useUserInformation } from '@Contexts/session';
import { useMemo } from 'react';
import { useCustomDomainName } from './CustomDomainContext';
import { filterCustomDomainPartnerships } from './customDomainPartnerships';

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** The user information with only the partnerships the user may log into on this domain. */
export function useCustomDomainUserInformation() {
    const userInformation = useUserInformation();
    const customDomain = useCustomDomainName();
    const { data } = userInformation;

    const domainData = useMemo(
        () =>
            data && {
                ...data,
                partnerships: filterCustomDomainPartnerships(data.partnerships, data.brandings, customDomain),
            },
        [data, customDomain],
    );

    return { ...userInformation, data: domainData };
}
